/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const storeLocatorMapContainerSX: SxProps = {
	height: '80vh',
	maxHeight: '740px',
	margin: 0,
	padding: 0,
};

export const storeLocatorMapContainerSXMobile: SxProps = {
	height: '122px',
	maxWidth: '600px',
	width: '100%',
};

export const styleSideList: SxProps = {
	backgroundColor: '#FBFBFC',
};
